<template>
  <div class="search-box">
    <van-search
      class="sticky"
      v-model="keyword"
      shape="round"
      :placeholder="placeholder"
      @search="onSearch"
    >
    </van-search>
  </div>
</template>
<script>
export default {
  data() {
    return {
      keyword: "",
      show: false,
    };
  },
  props: {
    placeholder: {
      type: String,
      default: "输入设备名称",
    },
  },

  methods: {
    onSearch() {
      let data = {
        keyword: this.keyword,
      };
      if (!data.keyword) data = null;
      this.show = false;
      this.$emit("search", data);
    },
  },
};
</script>
<style lang="scss" scoped>
.search-box {
  &:deep(.van-search__action:active) {
    background-color: transparent;
  }
  // &:deep(.van-cell) {
  //   font-size: $contentFontSize;
  //   background: transparent;
  // }
  // &:deep(.van-search__content) {
  //   height: 60px;
  //   background: #f5f5f5;
  //   border-radius: 30px;
  // }
  &:deep(.van-field__body) {
    height: 100%;
  }

  .sticky {
    position: relative;
    z-index: 100;
  }
}
</style>



